export default {

    disabled: [

        'homepage.supported_countries',
        'homepage.compatibility_notice',
        'homepage.compatibility_notify',
        'homepage.cn_payment',
        'homepage.plan_once_per_user',
        'footer.gov_record',
        'cloud.paypal',
        'cloud.gtag',
        'cloud.country_select',
        'cloud.email_check',
        'help.community',
        'help.facebook',
        'help.twitter',
        'dashboard.plan_cancel',
        'dashboard.payment_history',
        'dashboard.used_space',
        'library.renewal'

    ]

};



// WEBPACK FOOTER //
// ./src/config/oem/reolink-cn/features.js